module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/admin/admin-cache/admin-cache.component.scss
// module id = ./client/app/admin/admin-cache/admin-cache.component.scss
// module chunks = main